export default function NoDataFound({ message = "No data available" }) {
  return (
    <div
      className="d-flex justify-content-center align-items-center text-center"
      style={{ height: "50vh" }}
    >
      <h5 className="text-white">{message}</h5>
    </div>
  );
}
